(function (t) {
// fr
t.add("form.title", "Trouvez une activit\u00e9 \u00e0 proximit\u00e9", "front", "fr");
t.add("form.subtitle", "Une diversit\u00e9 d'exp\u00e9riences pour satisfaire toutes vos envies", "front", "fr");
t.add("form.submit", "Rechercher", "front", "fr");
t.add("activity_form.address_validation_error", "Veuillez pr\u00e9ciser votre emplacement", "front", "fr");
})(Translator);
